/**
 * バリデーションメッセージ定数
 * アプリケーション全体で使用されるバリデーションエラーメッセージを定義する
 */

/** 必須フィールドのエラーメッセージ */
export const REQUIRED_MESSAGE = "このフィールドは必須です。";

/** カタカナ入力要求のエラーメッセージ */
export const KATAKANA_MESSAGE = "カタカナを入力してください。";

/** 顧客ID文字数制限のエラーメッセージ */
export const CUSTOMER_ID_MESSAGE = "カルテNo.は10文字以内で入力してください。";

/** メールアドレス形式のエラーメッセージ */
export const EMAIL_MESSAGE = "無効なメールアドレスです。";

/** 誕生日の日付制限のエラーメッセージ */
export const BIRTH_DAY_MESSAGE = "誕生日が本日より大きくすることはできません。";

/** メモ必須入力のエラーメッセージ */
export const REQUIRED_MEMO_MESSAGE = "メモを入力してください。";

/** メモ文字数制限のエラーメッセージ */
export const MAX_CHARACTERS_MEMO_MESSAGE = "300文字以下にしてください。";

/** 開始時間が終了時間より後のエラーメッセージ */
export const START_END_TIME_MESSAGE = "終了時間より大きくすることはできません。";

/** 終了時間が開始時間より前のエラーメッセージ */
export const END_START_TIME_MESSAGE = "開始時間より過去にすることはできません。";

/** 終了時間が夜晩より後のエラーメッセージ */
export const END_START_MID_DAY_TIME_MESSAGE = "夜晩より大きくすることはできません。";

/** 開始時間が朝晩より前のエラーメッセージ */
export const START_END_MID_DAY_TIME_MESSAGE = "朝晩より過去にすることはできません。";
